import { post, put, get, del } from "../fetch.v2"
import { ISettingFrontOfficeCreate } from "../../interfaces/setting"
import { getEventId, getDomainId } from "../../utils/store"

class SettingApi {
  url: string

  constructor() {
    const domainId = getDomainId()
    const eventId = getEventId()
    this.url = `/domains/${domainId}/events/${eventId}/settings/fo`
  }

  async getOne(forExhibitor?: boolean) {
    return get(`${this.url}${forExhibitor ? "?forExhibitor=true" : ""}`)
  }

  async createOrUpdateOne(setting: ISettingFrontOfficeCreate) {
    return put(this.url, setting)
  }
}

export default SettingApi
